<template>
  <PersonalPages v-if="isPersonalOrganization" :id="pageId" />
  <TeamPages v-else :org-id="orgId" :row-id="pageId" />
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

import * as inject from "@/components/inject";
import PersonalPages from "@/routes/PersonalPages.vue";
import TeamPages from "@/routes/TeamPages.vue";

export default defineComponent({
  name: "PagesRoute",
  components: {
    PersonalPages,
    TeamPages,
  },
  props: {
    orgId: { type: String, required: true },
    pageId: { type: String, required: false },
  },
  setup(props) {
    const profile = inject.profile();
    const isPersonalOrganization = computed(
      () => props.orgId === profile.value.user.personal.organizationId
    );

    return {
      isPersonalOrganization,
    };
  },
});
</script>
